import { Copy } from "lucide-react";
import React from "react";

import { showToast } from "@/components/ui";

// Same pattern as the orders drawer's CopyBtn; stopPropagation because the row navigates.
export const CopyBtn: React.FC<{ text: string }> = ({ text }) => (
  <button
    data-testid={`copy-${text}`}
    title="Copy store ID"
    aria-label="Copy store ID"
    onClick={async (e) => {
      e.stopPropagation();
      try {
        await navigator.clipboard.writeText(text);
        showToast.info("Copied", text);
      } catch {
        // Denied permission or an insecure context: never claim a copy that did not happen.
        showToast.error("Copy failed", text);
      }
    }}
    className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
  >
    <Copy className="w-3 h-3" />
  </button>
);
